"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBorrowSupportedChainId = void 0;
const constants_1 = require("./constants");
const BorrowSupportedChainIds = [constants_1.ChainId.ARBITRUM, constants_1.ChainId.AVALANCHE, constants_1.ChainId.MAINNET, constants_1.ChainId.OPTIMISM, constants_1.ChainId.POLYGON];
const isBorrowSupportedChainId = (chainId) => {
    return BorrowSupportedChainIds.includes(chainId);
};
exports.isBorrowSupportedChainId = isBorrowSupportedChainId;
//# sourceMappingURL=borrow.js.map